:host {
  @include cms-components-host-defaults;
  @include cms-margin-center;

  max-width: var(--cms-container-max-width);
  margin-bottom: var(--cms-components-mb);
  padding: 0 1rem;

  & a {
    @include cms-anchor-base-font;
  }

  & .visible-text p {
    margin-bottom: 0;
  }

  & .hidden-text {
    height: 0;
    overflow: hidden;
    transition: height 0.3s ease-out;
    will-change: transform;

    & .hidde.content p {
      margin-bottom: 0.75rem;
      margin-top: 0;
    }
  }

  & .button-wrapper {
    text-align: center;
  }

  @include media-width($breakpoint-md) {
    cms-button {
      width: 66.66%;
    }
  }
}
